'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { Suspense, useEffect } from 'react'
import NProgress from 'nprogress'

// NProgress shows the yellow progress bar on the page top
NProgress.configure({ showSpinner: false })

const RouterEventsComponent = () => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // We cant subscribe to the router event so we will detect routing change
  // by the url change
  useEffect(() => {
    NProgress.done()
    return () => {
      NProgress.start()
    }
  }, [pathname, searchParams])
  return null
}

export const RouterEvents = () => {
  return (
    <Suspense>
      <RouterEventsComponent />
    </Suspense>
  )
}
